
import { Page } from "app/multi_device"
import isBlankStr from "underscore.string/isBlank"
import {
  PriceDropdown,
  InputSelector as BaseInputSelector,
} from "components/dropdown_menu/desktop/price_dropdown"
import {
  CurrencySelector,
  Factory as CurrencySelectorFactory,
} from "../currency_selector/index"

export type InputSelector = BaseInputSelector & {
  scope?: JQuery | string
  main?: JQuery | string
  min_select?: JQuery | string
  max_select?: JQuery | string
  toggle?: JQuery | string
  dropdown?: JQuery | string
  min_wrapper?: JQuery | string
  max_wrapper?: JQuery | string
}
const DEFAULT_SELECTOR = {
  scope:        ".cell--buildings--overseas-marketing--filter",
  main:         ".cell--buildings--overseas-marketing--filter--form__price-dropdown-container",
  min_select:   ".filter-option-min",
  max_select:   ".filter-option-max",
  toggle:       ".dropdown-with-input-toggle",
  dropdown:     ".dropdown-menu-with-input",
  max_wrapper:  ".filter-option--price-max",
  min_wrapper:  ".filter-option--price-min",
  angle:        ".btn i",
}

export class SAPriceDropdown extends PriceDropdown {
  protected name: string

  protected currency_selector?: CurrencySelector

  protected has_url_params = false

  constructor(selector?: InputSelector){
    const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    super(merged_selector)

    this.name = "SA_page_price_dropdown_blueprint"

    this.currency_selector = CurrencySelectorFactory.create()

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)

    if (urlParams.get("overseas_properties_listing_search_criteria_set[maximum_price]") || urlParams.get("overseas_properties_listing_search_criteria_set[minimum_price]")) {
      this.has_url_params = true
    }
  }

  public show(): void {
    this.$el.addClass("shown")
  }

  public hide(): void {
    this.$el.removeClass("shown")
  }

  protected selected_currency_price_dropdown(): JQuery<HTMLElement> {
    return this.$dropdown.filter("[data-currency=" + this.currency_selector?.val() + "]")
  }

  // override functions below for special case handling
  protected showDropdown(): void {
    this.selected_currency_price_dropdown().show()
  }
  protected hideDropdown(): void {
    this.$dropdown.hide()
  }
  protected updateMinChosenPlaceHolder(): void {
    const min_selected_el = this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.min_select).find("option:selected")
    if ( !isNaN( parseInt(min_selected_el.val(), 10) ) ){
      this.$min_wrapper.find("input").attr("placeholder", min_selected_el.text())
    }
    else{
      this.$min_wrapper.find("input").attr("placeholder", this.$min_select.data("placeholder"))
    }
  }
  protected updateMaxChosenPlaceHolder(): void {
    const max_selected_el = this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.max_select).find("option:selected")
    if ( !isNaN( parseInt(max_selected_el.val(), 10) ) ){
      this.$max_wrapper.find("input").attr("placeholder", max_selected_el.text())
    }
    else{
      this.$max_wrapper.find("input").attr("placeholder", this.$max_select.data("placeholder"))
    }
  }
  protected convertValueToLabel(): string {
    let min_value = this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.min_select).val()
    let max_value = this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.max_select).val()

    if (this.has_url_params) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      min_value = (urlParams.get("overseas_properties_listing_search_criteria_set[minimum_price]")?.toString())
      max_value = (urlParams.get("overseas_properties_listing_search_criteria_set[maximum_price]")?.toString())

      this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.max_select).find("option[value=" + max_value +"]").prop("selected", true)
      this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.min_select).find("option[value=" + min_value +"]").prop("selected", true)

      this.has_url_params = false
    }

    if (!isBlankStr(min_value) && !isBlankStr(max_value)) {
      return `${this.convert(min_value)} - ${this.convert(max_value)}`
    }
    else if (!isBlankStr(min_value)){
      return `> ${this.convert(min_value)}`
    }
    else if ( !isBlankStr(max_value) ){
      return `< ${this.convert(max_value)}`
    }
    else {
      return this.$selected_text.data("original-text")
    }
  }
  public count(): number {
    const min_select = this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.min_select)
    const max_select = this.selected_currency_price_dropdown().find(DEFAULT_SELECTOR.max_select)

    return [max_select, min_select].reduce((memo, $el) => {
      const selected = $el.find("option:selected")
      const first = $el.find("option:first")
      if (selected.length === 1 && selected.is(first)){
        return memo
      }

      return memo + 1
    }, 0)

  }
}


const Factory = {
  create(selector?: InputSelector): SAPriceDropdown {
    if (! Page.isForDesktop() && ! Page.isForTablet()){
      throw new Error("Desktop.PriceDropdownContainer called for incorrect page version")
    }
    return new SAPriceDropdown(selector)
  },
}

export {
  Factory,
}
